// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Invitation_titleWrapper__XRJxn","invitationWrapper":"Invitation_invitationWrapper__gfGtr","desc":"Invitation_desc__caL21"};